import React from "react";

// Source
import StoreLocalization from "../store/Localization";
import StoreRole from "../store/Role";
import * as HelperSrc from "../HelperSrc";
import * as ModelLocalization from "../model/Localization";
import * as ModelRoute from "../model/Route";
import * as ModelRole from "../model/Role";

export default class ControllerAccessDenied {
    // Variable
    private props: ModelRoute.Iprops;

    private storeLocalization: ModelLocalization.Istore<ModelLocalization.Idata>;
    private storageLocalizationData = React.useRef<ModelLocalization.Idata | undefined>(undefined);
    private storeRole: ModelRole.Istore;
    private storageRoleData = React.useRef<ModelRole.Idata | undefined>(undefined);

    private elementViewMain = React.useRef<HTMLElement | null>(null);

    private isRendered = React.useRef<boolean>(false);

    getRoleRequire: string | undefined;
    setRoleRequire: React.Dispatch<React.SetStateAction<string | undefined>>;

    // Method
    constructor(props: ModelRoute.Iprops, isRendered: boolean) {
        this.props = props;

        this.storeLocalization = new StoreLocalization();
        this.storageLocalizationData.current = this.storeLocalization.storageGet();
        this.storeRole = new StoreRole();
        this.storageRoleData.current = this.storeRole.storageGet();

        this.isRendered.current = isRendered;

        const [getRoleRequire, setRoleRequire] = React.useState<string | undefined>(undefined);
        this.getRoleRequire = getRoleRequire;
        this.setRoleRequire = setRoleRequire;
    }

    initializeHook = (): void => {
        React.useEffect(() => {
            HelperSrc.domObserver(".view_access_denied", () => {
                this.initializeHtmlElement();
            });
        }, []);

        React.useEffect(() => {
            this.storageLocalizationData.current = this.storeLocalization.storageGet();
            this.storageRoleData.current = this.storeRole.storageGet();

            let result = "";

            if (this.props.role) {
                for (const role of this.props.role) {
                    if (!this.storageLocalizationData.current || !this.storageRoleData.current) {
                        break;
                    }

                    for (const roleKey of Object.keys(this.storageRoleData.current)) {
                        if (role === this.storageRoleData.current[roleKey]) {
                            result = result.concat(` "${this.storageLocalizationData.current[`role_${roleKey}`] as string}" `);

                            break;
                        }
                    }
                }
            }

            this.setRoleRequire(result);
        }, [this.storageLocalizationData.current, this.storageRoleData.current]);
    };

    private initializeHtmlElement = (): void => {
        if (!this.elementViewMain.current) {
            this.elementViewMain.current = document.querySelector<HTMLElement>(".view_access_denied");
        }
    };
}
